// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseProgramCaseTypeModels {
    static getAttributeTypeMap() {
        return CaseProgramCaseTypeModels.attributeTypeMap;
    }
}
CaseProgramCaseTypeModels.discriminator = undefined;
CaseProgramCaseTypeModels.additionalProperties = false;
CaseProgramCaseTypeModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=caseProgramCaseTypeModels.js.map